import ProductTags from './ProductTags';

export default ProductTags;


// WEBPACK FOOTER //
// ./src/modules/ProductTags/index.tsx